import React, { useState, useEffect, createContext, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { callApi, resolveOrientation, setCookie, getCookie, callGameServerApi, getView, getViewerView } from './Helpers';
import MainLoader from './components/MainLoader';
import { WEB_SOCKET_URL } from './games-ui/CoreHelper';
import MainBody from './components/MainBody';
import OverlayLoader from './components/OverlayLoader';
import ConfirmDialog from './components/ConfirmDialog';
import EventDialog from './components/EventDialog';
import NetworkError from './components/NetworkError';
import { Toaster, toast } from 'react-hot-toast';
import Viewer from './components/Viewer';
import { MdOutlineNotifications } from 'react-icons/md';
import _ from 'lodash';
import { generateRandomString } from './games-ui/CoreHelper';
import MobileInterface from './MobileInterface';


export const AppContext = createContext(null);
export default function App(props) {

  const initDelay = 0; //startup delay in millisecs
  const refreshInterval = 1000; //interval to refresh background activities
  const { _navItem, _navSubItem, _navExtraItem } = useParams(); //for routing purposes
  const [ navItem, setNavItem ] = useState(_navItem);
  const [ navSubItem, setNavSubItem ] = useState(_navSubItem);
  const [ navExtraItem, setNavExtraItem ] = useState(_navExtraItem);
  const [ userData, setUserData ] = useState(null);
  const [ auth, setAuth ] = useState(false);
  const [ mainParams, setMainParams ] = useState({});
  const [ ready, setReady ] = useState(false);
  const [ orientation, setOrientation ] = useState(resolveOrientation(window.screen.orientation.type));
  const [ prevOrientation, setPrevOrientation ] = useState('');
  const [ showOverlayLoader, setShowOverlayLoader ] = useState(false);
  const [ orientationError, setOrientationError ] = useState(false);
  const [ showDialog, setShowDialog ] = useState(false);
  const [ dialogMessage, setDialogMessage ] = useState("");
  const [ showDialog2, setShowDialog2 ] = useState(false);
  const [ dialogMessage2, setDialogMessage2 ] = useState("");
  const [ dialogOnConfirm, setDialogOnConfirm ] = useState(null);
  const [ showViewer, setShowViewer ] = useState(false);
  const [ viewType, setViewType ] = useState(false);
  const [ viewId, setViewId ] = useState(false);
  const [ newAlertsNotified, setNewAlertsNotified ] = useState(false);
  const [ db, setDb ] = useState(null);

  //views mods
  const [ mainView, setMainView ] = useState(<></>);
  const [ viewerView, setViewerView ] = useState(<></>);

  //websocket handling
  const wsRandomId = generateRandomString();
  const webSocketRef = useRef(null)
  const [ webSocketConnected, setWebSocketConnected ] = useState(2); //0 = not, 1=conn, 2= start
  const [ webSocketReconnectTimer, setWebSocketReconnectTimer ] = useState(null);



  const refresh = async () => {
    //refresh app here
    await init().then(() => {
      //..
    })
  }

  const deleteLocalUsers = () => {
    return new Promise(async resolve => {
      setCookie('userId', '', -30);
      setCookie('userToken', '', -30);
      resolve(true);
    })
  }

  function setupWebSocket() {
    getLocalUser().then(_user => {
      if(_user && webSocketConnected !== 1) {
        //..
        webSocketRef.current = new WebSocket(WEB_SOCKET_URL);
        webSocketRef.current.addEventListener('open', async () => {
          //send subscription message
          // using delay hack
          setTimeout(async () => {
            if(webSocketRef.current.readyState === WebSocket.OPEN) {

              //subscribe for game data
              webSocketRef.current.send(JSON.stringify({
                type: 'subscribe-for-user-data',
                userId: _user.userId,
                userToken: _user.userToken,
                sourceId: 'userData'+wsRandomId,
              }))

            }
          }, 3000);
          setWebSocketConnected(1);
        })

        webSocketRef.current.addEventListener('close', (e) => {
          if(!e.wasClean) {
            setWebSocketConnected(0);
            //try to reconnect after 5 seconds
            setWebSocketReconnectTimer((prevTimer) => {
              if(prevTimer) {
                clearInterval(prevTimer);
              }

              let timer = setInterval(() => {
                setupWebSocket();
              }, 5000);

              return timer;
            })
          }
        })

        webSocketRef.current.addEventListener('message', (e) => {
          const response = JSON.parse(e.data);
          if(response.type === 'user-data') {
            handleUserDataChange(response.userData);
          } 
        })
        //..
      }
    })
    //subscribe for game data updates
    

    

    
  }

  function closeWebSocket() {
    //send unsubscribe req
    getLocalUser().then(_user => {
      if(_user) {
        //...
        if(webSocketRef.current && webSocketRef.current.readyState === WebSocket.OPEN) {
          webSocketRef.current.send(JSON.stringify({
            type: 'unsubscribe-for-user-data',
            userId: _user.userId,
            userToken: _user.userToken,
            sourceId: 'userData'+wsRandomId,
          }))
    
        }
    
        //then close connection
        if(webSocketRef.current) {
          webSocketRef.current.close();
          setWebSocketConnected(0);
        }
    
        //clear  reconnect timer
        if(webSocketReconnectTimer) {
          clearInterval(webSocketReconnectTimer);
        }
        //...
      } 
    })
    
  }


  const saveLocalUser = (user) => {
    return new Promise (async resolve => {
      //delete local users firt
      await deleteLocalUsers().then(async () => {
        //thenn save this user
        setCookie('userId', user.userId, 90);
        setCookie('userToken', user.userToken, 90);
        resolve(true);
        
      })
    })
  }


  const getLocalUser = () => {
    return new Promise(async resolve => {
      //use cookies
      let userId = getCookie('userId');
      let userToken = getCookie('userToken');
      resolve({
        userId,
        userToken,
      })

    })
  }


  const soundEffectsPlayer = (rings) => {
    rings.forEach((item, i) => {
      MobileInterface.playSound(item)
    })
  }

  
  const activateDialog = (params) => {
    let {
      message,
      onConfirm
    } = params;
    setDialogOnConfirm(() => { return onConfirm });
    setDialogMessage(message);
    setShowDialog(true);
  }

  const activateDialog2 = (params) => {
    let {
      message,
    } = params;
    setDialogMessage2(message);
    setShowDialog2(true);

    //play alert sound
    //soundEffectsPlayer(['alert']);
  }

  const tellError = (error) => {
    toast.error(error, {
      style: {
        borderRadius: '10px',
        background: 'var(--faintBlack)',
        color: 'var(--whitish)',
      },
    });
  }

  const tellMessage = (message) => {
    toast.success(message, {
      style: {
        borderRadius: '10px',
        background: 'var(--faintBlack)',
        color: 'var(--whitish)',
      },
    });
  }

  const navBack = () => {
    window.history.back();
  }

  const scrollTop = () => {
    window.scrollTo({
     top: 0,
     behavior: "smooth"
   });
  }

  const navHome = () => {
    window.location.href="/";
  }

  const navTo = (nav) => {
    
    if(nav) {

      if(auth) {
        let link = '';

        if(nav.item) {
          link += `#/${nav.item}`
        }

        if(nav.subItem) {
          link += `/${nav.subItem}`
        }

        if(nav.extraItem) {
          link += `/${nav.extraItem}`
        }

        window.location.href = link;

      } else {
        if(nav.item === 'signin' || nav.item === 'signup' || nav.item === 'reset_pwd' ) {
          //...
          //go on as usual
          let link = '';

          if(nav.item) {
            link += `#/${nav.item}`
          }

          if(nav.subItem) {
            link += `/${nav.subItem}`
          }

          if(nav.extraItem) {
            link += `/${nav.extraItem}`
          }

          window.location.href = link;
          //...
        } else {
          navTo({
            item: 'signin',
          })
        }
      }

      
    }

  }


  const openHome = () => {
    window.location.href = '/';
  }

  const openLogin = () => {
    window.location.href = '#/signin';
  }

  const checkAuth = () => {
    return new Promise(async resolve => {
      await callGameServerApi('auth-check', { }).then(async response => {
        let _auth = (response.auth === 1) ? true : false;
        if(_auth) {
          setAuth(_auth);
          resolve(response);
        } else {
          //check if local user was saved
          setAuth(false);
          resolve(false);
        }
        
      })

      
    })
  }

  const getUserData = () => {
    return new Promise(async resolve => {
      await callGameServerApi('get-current-user', {}).then(response => {
        handleUserDataChange(response.userData);
        resolve(response);
      })
    })
  }

  const getMainParams = () => {
    return new Promise(async resolve => {
      await callGameServerApi('get-main-params', { }).then(response => {
        if(response.status === 1) {
          setMainParams(response.mainParams);
          resolve(response.mainParams);
        }
      })

    })
  }



  const init = async () => {
    return new Promise(async resolve => {
      //..
      setReady(false);
      await getMainParams().then(async () => {
        await checkAuth().then(async response => {
          if(response.auth === 1) {
            setupWebSocket();
            await getUserData().then((response) => {
              
              setTimeout(() => {  
                setReady(true)
                resolve();
              }, initDelay);
            })

          }
          else {
            setTimeout(() => {
              setReady(true)
              resolve();
            }, initDelay);
          }
        })
      })
      //..
    })
  }

  const changeOrientation = (_orientation) => {
    //setOrientation(_orientation);
    setOrientation((_prev) => {
      return _orientation;
    })
  }

  const forceChangeOrientation = (_orientation) => {
    if(_orientation !== orientation) {
      setOrientation((_prev) => {
        return _orientation;
      })
    }

    
  }

  const handleUserDataChange = (newData) => {
    setUserData(oldData => {

      //checking for new alerts
      if(newData) {
        if(!oldData) {
          if(JSON.parse(newData.newAlerts).length > 0) {
            activateDialog2({
              message: (
                <div className="text-center" style={{ width: "100%", paddingTop: "10px", paddingLeft: "4px", paddingRight: "4px", marginTop: "10px",marginBottom: "5px" }}>
                  <MdOutlineNotifications size={40} style={{ marginBottom: "20px" }}/>
                  <br/>
                  <h6 className="font-light">You have new Alert</h6>
                  <button onClick={() => {window.location.href='#/alerts'; document.getElementById('_dialogCloser2').click()}} className="btn bg-blackish btn-block" style={{ margin: "0px", border: "1px solid var(--goldish)" }}>View Alerts</button>
                </div>
              ),
            })
          }
        }
        else if(JSON.parse(newData.newAlerts).length > 0) {
          if(!_.isEqual(JSON.parse(newData.newAlerts), JSON.parse(oldData.newAlerts))) {
            activateDialog2({
              message: (
                <div className="text-center" style={{ width: "100%", paddingTop: "10px", paddingLeft: "4px", paddingRight: "4px", marginTop: "10px",marginBottom: "5px" }}>
                  <MdOutlineNotifications size={40} style={{ marginBottom: "20px" }}/>
                  <br/>
                  <h6 className="font-light">You have new Alert</h6>
                  <button onClick={() => {window.location.href='#/alerts'; document.getElementById('_dialogCloser2').click()}} className="btn bg-blackish btn-block" style={{ margin: "0px", border: "1px solid var(--goldish)" }}>View Alerts</button>
                </div>
              ),
            })
          }
        }
      }

      return newData;
    })
  }

  

  const appContext = {
    navItem,
    navSubItem,
    navExtraItem,
    refresh,
    navTo,
    checkAuth,
    getUserData,
    init,
    auth,
    userData,
    changeOrientation,
    openHome,
    setShowOverlayLoader,
    setOrientationError,
    openLogin,
    mainParams,
    activateDialog,
    activateDialog2,
    refreshInterval,
    tellError,
    tellMessage,
    navBack,
    showViewer,
    viewId,
    viewType,
    setShowViewer,
    newAlertsNotified,
    setNewAlertsNotified,
    getMainParams,
    forceChangeOrientation,
    soundEffectsPlayer,
    getLocalUser,
    saveLocalUser,
    deleteLocalUsers,
    navHome,
    viewerView,
    mainView,
  }


  useEffect(() => {
    //make real initializations here coz db is ready
    //set Soldrax for window
    window.SOLDRAX = appContext;
    //then initialize the app here
    init();

    return () => {
      closeWebSocket();
    }
  }, []);

  
  

  useEffect(() => {
    getUserData();
  }, [ auth ]);

  useEffect(() => {
    setNavItem(_navItem);
    setNavSubItem(_navSubItem);
    setNavExtraItem(_navExtraItem);
  }, [ _navItem, _navSubItem, _navExtraItem ])

  

  useEffect(() => {
    //scroll to top
    //scrollToTop();
    
    //check for viewerView
    if(navItem === 'view' ) {
      //activate viewer
      setShowViewer(true);
      setViewerView(getViewerView(navSubItem, navExtraItem));
    } else {
      //just set normal views
      setShowViewer(false);
      setViewerView(null);
      setMainView(getView(appContext))
    }

    getUserData(); //temporally userdata refresh to be replaced with websockets
  }, [ navItem, navSubItem, navExtraItem ])

  useEffect(() => {
    if(userData) {
      //setup websocket if not
      //set onesignal external id
      MobileInterface.setOneSignalExternalUserId(userData.id);

    }
  }, [ userData ])

  
  //render here
  if(ready) {
    return (
      <AppContext.Provider value={appContext}>
        <Viewer/>
        {/* <NetworkError/> */}
        <EventDialog show={showDialog2} message={dialogMessage2} />
        <ConfirmDialog show={showDialog} message={dialogMessage} onConfirm={dialogOnConfirm} />
        <OverlayLoader show={showOverlayLoader}/>
        <Toaster
          position="bottom-center"
          reverseOrder={true}
          containerStyle={{
            zIndex: "calc(1 + var(--superUltraHighIndex))"
          }}
        />
        
        <MainBody/>
      </AppContext.Provider>
    );
  }
  else {
    return (
      <AppContext.Provider value={appContext}>
        <Viewer/>
        
        {/* <NetworkError/> */}
        <EventDialog show={showDialog2} message={dialogMessage2} />
        <ConfirmDialog show={showDialog} message={dialogMessage} onConfirm={dialogOnConfirm} />
        <Toaster
          position="bottom-center"
          reverseOrder={true}
          containerStyle={{
            zIndex: "calc(1 + var(--superUltraHighIndex))"
          }}
        />
        <OverlayLoader show={showOverlayLoader}/>
        <MainLoader/>
        
      </AppContext.Provider>
    );
  }
}
